/* eslint-disable react/style-prop-object */
import React, { ReactElement, useState } from "react";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import AppModal from "components/shared/modal/AppModal";

import {
 getMinMailboxNumber,
 postUpgradingToMailPro
} from "redux/handlers/mailDomainContainerHandler";

import { getUserBalance } from "redux/selectors/userSelector";

import { useAppDispatch } from "hooks/reduxHook";

const UpgradeToMailPro = ({ id }: { id: number }): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const userBalance = useSelector(getUserBalance);

 const [open, setOpen] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);
 const [selectedNumber, setSelectedNumber] = useState<number>(5);
 const [minNumber, setMinNumber] = useState<number>(5);

 const handleOpen = async () => {
  const mailNumber = await dispatch(getMinMailboxNumber(id));
  setMinNumber(mailNumber);
  setSelectedNumber(mailNumber);
  setOpen(true);
 };
 const handleClose = () => setOpen(false);

 const handleConfirm = async () => {
  setLoading(true);
  await dispatch(postUpgradingToMailPro(id, selectedNumber));
  setLoading(false);
  handleClose();
 };

 return (
  <>
   <Button variant="kxModalConfirm" onClick={handleOpen}>
    <FormattedMessage id="container.maildomains.upgradeToPro" />
   </Button>
   <AppModal
    open={open}
    close={handleClose}
    title={intl.formatMessage({ id: "container.maildomains.upgradeToPro" })}
    handleClose={handleClose}
    handleConfirm={handleConfirm}
    disabled={loading || userBalance < 1.8 * selectedNumber || selectedNumber < minNumber}>
    <Stack>
     <Stack spacing={2}>
      <Stack>
       <Typography variant="subtitle2">
        <FormattedMessage id="container.maildomains.mailProDescription" />
       </Typography>
       <Typography variant="subtitle2">
        <FormattedMessage id="container.maildomains.mailProList" values={{ br: <br /> }} />
       </Typography>
       <Typography variant="subtitle2">
        <FormattedMessage id="container.maildomains.mailProMailbox" />
       </Typography>
      </Stack>
      <Typography variant="subtitle2">
       <FormattedMessage
        id="container.maildomains.minMailboxProNumber"
        values={{ min: minNumber }}
       />
      </Typography>
      <TextField
       fullWidth={true}
       type="number"
       InputLabelProps={{ shrink: true }}
       sx={{ my: 2 }}
       autoComplete="off"
       value={selectedNumber}
       onChange={({ currentTarget }) => setSelectedNumber(Number(currentTarget.value))}
      />
     </Stack>
     <Stack direction="row" spacing={2} mt={1}>
      <Typography minWidth={150} textAlign="start" fontWeight="bold">
       <FormattedMessage id="server.add.balance" />
      </Typography>
      <Typography>
       <FormattedNumber value={userBalance} style={"currency"} currency="EUR" />
      </Typography>
     </Stack>
     <Stack direction="row" spacing={2}>
      <Typography minWidth={150} textAlign="start" fontWeight="bold">
       <FormattedMessage id="container.maildomains.proPriceTotal" />
      </Typography>
      <Typography>
       <FormattedNumber value={1.8 * selectedNumber} style={"currency"} currency="EUR" />
      </Typography>
     </Stack>
    </Stack>
   </AppModal>
  </>
 );
};

export default UpgradeToMailPro;
